export default {
  listTitleTable: {
    COM_GROUP_CODE: 'CHỈ SỐ',
    INDEX_VALUE: 'GIÁ',
    INDEX_CHANGE: 'THAY ĐỔI',
    PERCENT_INDEX_CHANGE: '% THAY ĐỔI',
    TOTAL_MATCH_VOLUME: 'KHỐI LƯỢNG',
    TOTAL_MATCH_VALUE: 'GIÁ TRỊ',
    FOREIGN_BUY_VALUE_MATCHED: 'KLNN MUA',
    FOREIGN_SELL_VALUE_MATCHED: 'KLNN BÁN',
    FOREIGN_NET_VOLUME: 'KLNN RÒNG',
    FOREIGN_NET_VALUE: 'GTNN RÒNG',
    TOTAL_DEAL_VOLUME: 'KLGD THỎA THUẬN',
    TOTAL_DEAL_VALUE: 'GTGD THỎA THUẬN',
  },
  comGroupCode: {
    VNINDEX: 'VNINDEX',
    VN30: 'VN30',
    HNXINDEX: 'HNXINDEX',
    HNX30: 'HNX30',
    UPCOMINDEX: 'UPCOMINDEX',
    VNXALL: 'VNXALL',
    VN100: 'VN100',
    VNALL: 'VNALL',
    VNCOND: 'HÀNG TIÊU DÙNG',
    VNCONS: 'HÀNG TIÊU DÙNG THIẾT YẾU',
    VNDIAMOND: 'VNDIAMOND',
    VNENE: 'NĂNG LƯỢNG',
    VNFIN: 'TÀI CHÍNH',
    VNFINLEAD: 'VNFINLEAD',
    VNFINSELECT: 'VNFINSELECT',
    VNHEAL: 'CHĂM SÓC SỨC KHỎE',
    VNIND: 'CÔNG NGHIỆP',
    VNIT: 'CÔNG NGHỆ THÔNG TIN',
    VNMAT: 'NGUYÊN VẬT LIỆU',
    VNMID: 'VNMID',
    VNREAL: 'BẤT ĐỘNG SẢN',
    VNUTI: 'DỊCH VỤ TIỆN TÍCH',
    VNX50: 'VNX50',
  },
};
